import { createSelector } from 'reselect';

const substate = (state) => state.payment;

export const selectPaymentTransferResultHidden = () =>
    createSelector(substate, (contextState) => contextState.isPaymentTransfersResultHidden);
